import { getStandardHeaders } from '../utilities';
import { FetchMiddleware, ChirpGateway } from '../types';

export const setStandardHeaders: FetchMiddleware<{
  gateway: ChirpGateway;
  cookie: string;
}> = (params, context) => {
  const standardHeaders = getStandardHeaders(context.gateway, context.cookie);
  const updatedHeaders = { ...params.init?.headers, ...standardHeaders };
  return {
    ...params,
    init: {
      ...params.init,
      headers: updatedHeaders,
    },
  };
};
